export * from './set-standalone.action';
